export default {
  path: '/',
  component: () => import('@/layouts/LayoutContentAppNav.vue'),
  meta: { protected: true },
  children: [
    {
      path: 'hub/:pathMatch(.*)*',
      name: 'ModuleHub',
      component: () => import('@/views/hub/ModuleHub.vue'),
    },
  ],
}
